export default {
    title: "資源中心",
    subtitle: "金額申請",
    table1: "申請單號",
    table2: "申請人",
    table3: "申請金額",
    table4: "申請時間",
    table5: "備註",
    table6: "審批金額",
    table7: "審批時間",
    table8: "操作",
    table9: "狀態",
    agree1: "同意",
    agree2: "拒絕",
    agree3: "未確認",
    agree4: "已同意",
    agree5: "已拒絕",
    form1: "支援中心選擇",
    form2: "申請金額",
    form3: "備註",
    rule1: "請選擇支援中心人員",
    rule2: "請輸入申請金額",
    rule3: "請輸入申請備註",
    prompt1: "請輸入分配金額",
    prompt2: "請輸入備註",
    errmsg1: "金額已超出可分配額度，請重新輸入！",
    succmsg1: "操作成功！",
    succmsg2: "提交成功！",
}